import { useQuery } from '@tanstack/react-query';

import type { VetQueueHome } from '@shared/vetting/api';
import { vetKeys } from '@/components/Vet/useVetQueries';

import type { NavItemData } from '../components/NavigationItem';

/**
 * Counts beside nav entries, read from data a page already loaded: the
 * Flags entry shows the director's open flags from the vetting queue. The
 * drawer never fetches for a count; it reads the cache and follows it.
 */
export function useNavBadges(): Readonly<Record<string, number>> {
  const queue = useQuery<VetQueueHome>({
    queryKey: vetKeys.queue(),
    enabled: false,
  });
  const openFlags = queue.data?.openFlags ?? 0;
  return openFlags > 0 ? { 'vet-flags': openFlags } : {};
}

/** The items with their counts attached. */
export function withBadges<T extends NavItemData>(
  items: readonly T[],
  badges: Readonly<Record<string, number>>
): T[] {
  return items.map(item =>
    badges[item.id] ? { ...item, badge: badges[item.id] } : item
  );
}
